<template>
  <span class="atom-input-radio">
    <input
      :class="{ 'atom-input-radio--checked': inputValue }"
      type="radio"
      v-model="inputValue"
      :disabled="isDisabled"
    />
    <span class="atom-input-radio__radio" />
  </span>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'

/**
 * ラジオボタンを表示するAtomコンポーネント。
 */
export default defineComponent({
  name: 'AtomInputCheckbox',
  props: {
    /**
     * Value値
     */
    value: {
      type: Boolean,
      default: false,
    },
    /**
     * 非活性にするかどうか
     */
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    /**
     * inputValue
     * @param {string} val チェックボックスの値
     */
    const inputValue = computed({
      get: () => props.value,
      set: (val: boolean) => context.emit('input', val),
    })

    return {
      inputValue,
    }
  },
})
</script>

<style lang="scss" scoped>
.atom-input-radio {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;

  &__radio {
    position: relative;
    display: block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #f7f7f7;
    border: 1px solid rgba(0, 0, 0, 0.2);
    pointer-events: none;

    &::before {
      position: absolute;
      top: calc(50% - 5px);
      left: calc(50% - 5px);
      display: block;
      content: '';
      width: 10px;
      height: 10px;
      background: $white;
      border-radius: 50%;
    }
  }

  [type='radio'] {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0;
  }

  &--checked {
    + .atom-input-radio__radio {
      background: $green-light;
    }
  }
}
</style>
